// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ea7c23fc","885":"4115a31e"}[chunkId] + ".chunk.js";
};